"use strict";

var formatNumber = require("./number.formatter");
var debug = require("debug")("knack.formatter.formatters.currency");

/**
 * @alias "formatters.currency"
 * @param {Object} value Value to be formatted
 * @param {String} [format]  Currency format
 * @return {String}
 */
var currencyFormatter = function currencyFormatter(value, format) {
  var currencyFormat = Object.assign({
    precision: 2,
    show_commas: 1,
    format: "$"
  }, format);
  return formatNumber(value, currencyFormat);
};
module.exports = currencyFormatter;